import client from 'webpack-theme-color-replacer/client'
import appConfig from '../../config/app-config.js'
import $x from './$x';

export let curColor = appConfig.themeColor

// 使用过程中动态切换主题色
export function changeThemeColor(newColor, otherColors) {
    const options = {
        newColors: appConfig.getThemeColors(newColor, otherColors)
    }
    return client.changer.changeColor(options, Promise)
        .then(t => {
            curColor = newColor
            //localStorage.setItem('theme_color', curColor)
        });
}

// 初始化主题色
export function initThemeColor() {
    var info = $x.userInfo
    var otherColors = [
        info.titleBg || appConfig.titleBg,
        info.titleFg || appConfig.titleFg,
        info.footerBg || appConfig.footerBg,
    ]
    const savedColor = /*localStorage.getItem('theme_color') || */ info.themeColor || curColor
    if (savedColor) {
        document.body.style.visibility = 'hidden'
        return changeThemeColor(savedColor, otherColors).finally(() => {
            document.body.style.visibility = ''
        });
    }
    return Promise.resolve()
}
